import { render } from "./DepositDetailsByShareholder.vue?vue&type=template&id=5f40022d"
import script from "./DepositDetailsByShareholder.vue?vue&type=script&lang=js"
export * from "./DepositDetailsByShareholder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__